import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../components/Common/UI/Button';
import Separator from '../../../../../../components/Common/UI/Separator';
import DataTable from '../../../../../../components/Common/UI/DataTable';
import { campaignCol } from '../columns';
import { notifySuccess } from '../../../../../../components/Common/UI/Notify';
import { CampaignDialogData } from '../../columns';

function UnapproveCompanyDialog() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Dialog open={modalOpen} onOpenChange={isOpen => setModalOpen(isOpen)}>
      <DialogTrigger variant="ghost">
        <div className="flex gap-1 font-medium">
          <Icons.Unapprove className="text-primary" />
          Unapprove
        </div>
      </DialogTrigger>
      <DialogContent className="max-h-[98%]">
        <DialogTitle className="flex items-top gap-4 mb-[10px]">
          <Icons.Approve2 className="size-[34px]" />
          <div>
            <p className="text-xl leading-none">Unapprove Campaign</p>
            <p className="text-muted-foreground font-normal text-base">
              Some text info. Deleting of this campaign is permanent...
            </p>
          </div>
        </DialogTitle>
        <div className="grid grid-cols-3 gap-x-3 mb-[10px]">
          {CampaignDialogData.map(({ key, value }) => (
            <div className="grid grid-cols-[90px_1fr] gap-[10px]" key={key}>
              <div className="font-medium">{key}</div>
              <div className="opacity-60">{value}</div>
            </div>
          ))}
        </div>

        <DataTable columns={campaignCol} data={[{ id: 0 }]} variant="bordered" />
        <Separator className="!mt-4" />
        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button
            className="py-3"
            onClick={() => {
              setModalOpen(false);
              notifySuccess('Campaign unapproved');
            }}
          >
            Unapprove Campaign
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default UnapproveCompanyDialog;
